import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import {
  copyPrevMonth,
  getActionData,
  getActionsData,
  getInitDataVpo,
  getInitDataVpoSuccess,
  getReportCompletedActions,
  getReportFactory,
  getReportSummary,
  getReportActions,
  setCondition,
  setEndQuestionary,
  setReturnQuestionary,
  setStatusQuestionary,
} from "../actions";
import { PayloadAction } from "@reduxjs/toolkit";
import { ListFieldsKeys, ListFieldsRecordType } from "src/api/config";
import { GetSagaProps } from "src/modules/modules.type";
import { getDefaultSaga } from "./getDefaultSaga";
import { getItemsRequest } from "../../spItems/api";
import _ from "lodash";
import { setConditionSaga } from "./setConditionSaga";
import { getActionDataSaga } from "./getActionDataSaga";
import { getActionsDataSaga } from "./getActionsDataSaga";
import { setStatusQuestionarySaga } from "./setStatusQuestionarySaga";
import { setEndQuestionarySaga } from "./setEndQuestionarySaga";
import { copyPrevMonthSaga } from "./copyPrevMonthSaga";
import { getReportFactorySaga } from "./getReportFactorySaga";
import { getReportCompletedActionsSaga } from "./getReportCompletedActionsSaga";
import { getReportSummarySaga } from "./getReportSummarySaga";
import { setReturnQuestionarySaga } from "./setReturnQuestionarySaga";
import { getReportActionsSaga } from "./getReportActionsSaga";

export function* getSaga(action: PayloadAction<GetSagaProps>) {
  try {
    const payload = action.payload;
    let result: { items: ListFieldsRecordType[ListFieldsKeys]; nextPage?: string } | null = null;

    // if (payload.contentType == "GroupRequirements") {
    //   console.log("payload", payload);
    // }

    if (payload.all) {
      const { all, ...payload } = action.payload;

      let allItems: ListFieldsRecordType[ListFieldsKeys][] = [];
      let nextPage = null;

      do {
        // Выполни API-запрос и получи результат
        if (nextPage) {
          const resultAll: GetItemsResponse<ListFieldsKeys> = yield call(
            getItemsRequest,
            { ...payload, nextPage } // Передавай текущую страницу для загрузки данных
          );

          // Добавь текущие элементы к общему массиву
          allItems = [...allItems, ...resultAll.items];

          // Обнови `nextPage` из ответа, если он существует
          nextPage = resultAll.nextPage;
        }

        // Если `all` не установлен, выходим после первой загрузки
        if (!all) break;
      } while (nextPage); // Повторяй, пока существует следующая страница

      // Отправь все загруженные элементы в store после завершения всех запросов
      yield put(
        getInitDataVpoSuccess({
          items: allItems,
          listName: payload.listName,
          contentType: payload.contentType,
          filters: payload.filters,
        })
      );
    } else {
      result = yield call(getDefaultSaga, payload);
      // if (payload.contentType == "GroupRequirements") {
      //   console.log("payload", result);
      // }

      yield put(
        getInitDataVpoSuccess({
          ...result,
          listName: payload.listName,
          merge: payload.merge,
          contentType: payload.contentType,
          filters: payload.filters,
        })
      );
    }
  } catch (error) {
    console.log(error);
  }
}

interface GetItemsResponse<TListName extends ListFieldsKeys> {
  items: ListFieldsRecordType[TListName][];
  listName: TListName;
  contentType: string;
  nextPage: SP.ListItemCollectionPosition | null | undefined;
  count: number;
}

export function* vpoWatcher() {
  yield takeEvery(getInitDataVpo.toString(), getSaga);
  yield takeEvery(setCondition.toString(), setConditionSaga);
  yield takeEvery(getActionData.toString(), getActionDataSaga);
  yield takeEvery(getActionsData.toString(), getActionsDataSaga);
  yield takeLatest(setStatusQuestionary.toString(), setStatusQuestionarySaga);
  yield takeLatest(setEndQuestionary.toString(), setEndQuestionarySaga);
  yield takeLatest(copyPrevMonth.toString(), copyPrevMonthSaga);
  yield takeLatest(getReportFactory.toString(), getReportFactorySaga);
  yield takeLatest(getReportCompletedActions.toString(), getReportCompletedActionsSaga);
  yield takeLatest(getReportSummary.toString(), getReportSummarySaga);
  yield takeLatest(setReturnQuestionary.toString(), setReturnQuestionarySaga);
  yield takeLatest(getReportActions.toString(), getReportActionsSaga);
}
